<template>
    <section class="ob-inputs" id="on-behalf">
        <div v-if="isAdminUser" class="bold flex">Activate on behalf of:</div>
        <div class="flex" style="justify-content: space-between">
            <div class="flex" v-if="isAdminUser">
                <div style="padding-right: 10px; width: 300px">
                    <label class="co-select-input">
                        <v-select
                            dusk="on-behalf-account-component"
                            data-test="on-behalf-account-component"
                            placeholder="Select Account"
                            label="company"
                            append-to-body
                            class="co-custom-arrow"
                            :calculate-position="withPopper"
                            :clearable="false"
                            @input="updateOnBehalfAccount"
                            :reduce="(account) => account.id"
                            :options="this.formState.behalf_accounts_list"
                            v-model="formState.behalf_account"
                        >
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"
                                    ><chevron-down-icon :size="24"
                                /></span>
                            </template>
                        </v-select>
                    </label>
                </div>
                <div style="width: 300px">
                    <label class="co-select-input">
                        <v-select
                            dusk="on-behalf-user-component"
                            placeholder="Select a user"
                            name="type"
                            label="fullname"
                            class="co-custom-arrow"
                            append-to-body
                            :calculate-position="withPopper"
                            :clearable="false"
                            v-model="formState.behalf_user"
                            :options="this.formState.behalf_users_list"
                            @input="updateOnBehalfUser"
                        >
                            <template #open-indicator="{ attributes }">
                                <span v-bind="attributes"
                                    ><chevron-down-icon :size="24"
                                /></span>
                            </template>
                        </v-select>
                    </label>
                </div>
            </div>
            <div v-else></div>
            <div>
                <div style="width: 10%">
                    <button
                        type="button"
                        @click="saveProgram"
                        class="create-program-btn"
                    >
                        Activate
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import "./style.scss";
import { mapState, mapMutations, mapGetters, mapActions } from "vuex";
import { ChevronDownIcon } from "../../icons.js";
import { createPopper } from "@popperjs/core";

export default {
    props: {
        orderId: {
            type: [String, Number],
            default: 0,
        },

        editMode: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        ChevronDownIcon,
    },

    data() {
        let selected = Object.assign({}, this.selected);

        return {
            account: window.backend.account,
            isVisible: false,
            statusTimestamp: "",
            selectedItem: selected,
        };
    },


    computed: {
        ...mapState({
            formState: (state) => state.CreateProgramStore,
        }),
        ...mapGetters("AuthStore", ["isAdminUser"]),
        /**
         * Account users options list with full names
         *
         */
        accountUsersOptions() {
            return this.formState.behalf_accounts_list.map((user) => {
                let { firstname, lastname } = user;
                return Object.assign({}, user, {
                    fullname: `${firstname} ${lastname}`,
                });
            });
        },
    },

    mounted() {
        //get submit on behalf accounts
        this.getAccounts().then((accounts) => {
            this.updateBehalfAccountList(accounts)

            const authData = this.transformData(auth)

            //get default account users
            //@TODO - does this need to run here?
            if (this.isAdminUser) {
                this.getAccountUsers().then((accountUsers) => {
                    this.updateOnBehalfUserList(accountUsers);

                    //check if current auth user is in the list of accountUsers
                    let authUser = this.formState.behalf_users_list.find(
                        (user) => user.id == authData.id
                    );

                    if (authUser) {
                        this.setOnBehalfUser(authData);
                    }
                });
            } else {
                this.setOnBehalfUser(authData);
            }
        });
    },

    watch: {},



    methods: {
        ...mapMutations("CreateProgramStore", [
            "setOnBehalfAccount",
            "setOnBehalfUser",
            "updateDeliveryEmailOptions",
        ]),
        ...mapActions("CreateProgramStore", [
            "activateProgram",
            "updateBehalfAccountList",
            "updateOnBehalfUserList",
        ]),
        saveProgram() {
            this.activateProgram();
        },

        init() {
            //get uploaded files
            this.getUploadedFiles().then(this.mapUploadedFilesToFilepond);
        },

        /**
         * Get Accounts ( for on behalf submits )
         *
         */
        getAccounts() {
            return axios("/create-order/accounts").then(
                (result) => result.data.accounts
            );
        },

        /**
         * Get Account users ( for on behalf )
         *
         */
        getAccountUsers() {
            return axios(
                `/account/${this.formState.behalf_account}/users`
            ).then((result) => result.data.data);
        },

        /**
         * update on behalf account
         *
         */
        updateOnBehalfAccount($event) {
            this.setOnBehalfAccount($event);
            this.$nextTick(() => {
                this.getAccountUsers().then((accountUsers) => {
                    const authUserData = this.transformData(auth);
                    accountUsers.push(authUserData)
                    console.log(accountUsers, authUserData)
                    this.updateOnBehalfUserList(accountUsers);
                    this.setOnBehalfUser(authUserData);
                });
            });
        },

        updateOnBehalfUser(user) {
            this.setOnBehalfUser(user);
            this.updateDeliveryEmailOptions(user.email)
        },

        //checks if we are updating an existing(new) order
        isNewOrder() {
            return !_.isEmpty(this.orderId);
        },

        transformData(original){
            return {
                id: original.id,
                firstname: original.firstname,
                lastname: original.lastname,
                resource: original.resource,
                fullname: `${original.firstname} ${original.lastname}`
            }
        },

        /**
         * Check if files are currently uploading
         *
         * @return boolean
         */
        filesUploading() {
            let isUploading = false;

            if (this.filepondReady) {
                let perct = this.uploadingFiles().perct;
                isUploading = perct >= 1 && perct < 100;
            }

            return isUploading;
        },

        withPopper(dropdownList, component, { width }) {
            /**
             * We need to explicitly define the dropdown width since
             * it is usually inherited from the parent with CSS.
             */
            dropdownList.style.width = width;

            /**
             * Here we position the dropdownList relative to the $refs.toggle Element.
             *
             * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
             * the dropdownList overlap by 1 pixel.
             *
             * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
             * wrapper so that we can set some styles for when the dropdown is placed
             * above.
             */
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: "top",
                modifiers: [
                    {
                        name: "offset",
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: "toggleClass",
                        enabled: true,
                        phase: "write",
                        fn({ state }) {
                            component.$el.classList.toggle(
                                "drop-up",
                                state.placement === "top"
                            );
                        },
                    },
                ],
            });

            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy();
        },
    },



    directives: {},
};
</script>
